const DetailsContent = [
  { label: "Name", key: "Name" },
  { label: "Phone Number", key: "phone" },
  { label: "Email ID", key: "email" },
  { label: "WhatsApp Number", key: "whatsapp" },
  { label: "Company Name", key: "companyName" },
  {
    label: "Shipping Address",
    key: "shippingAddress",
    className: "has_two_cell",
  },
  { label: "City", key: "city" },
  { label: "State", key: "state" },
  { label: "Country", key: "country" },
  { label: "ZipCode", key: "zipCode" },
  // {
  //   label: "Billing Address",
  //   key: "billingAddress",
  //   className: "has_two_cell",
  // },
  { label: "GSTIN", key: "gstin" },
  { label: "PAN Details", key: "pan" },
  { label: "Website", key: "website" },
  { label: "MSME Details", key: "msme" },
];

const DetailsInputFields = [
  { label: "Name", name: "Name" },
  { label: "Phone Number", name: "phone" },
  { label: "Email ID", name: "email", type: "email" },
  { label: "WhatsApp Number", name: "whatsapp" },
  { label: "Company Name", name: "companyName" },
  {
    label: "Shipping Address",
    name: "shippingAddress",
    className: "has_two_cell",
  },
  { label: "City", name: "city" },
  { label: "State", name: "state" },
  { label: "Country", name: "country" },
  { label: "ZipCode", name: "zipCode" },
  // {
  //   label: "Billing Address",
  //   name: "billingAddress",
  //   className: "has_two_cell",
  // },
  { label: "GSTIN", name: "gstin" },
  { label: "PAN Details", name: "pan" },
  { label: "Website", name: "website" },
  { label: "MSME Details", name: "msme" },
];

const ordersDurationOptions = [
  { label: "1 Month", value: "1" },
  { label: "3 Months", value: "3" },
  { label: "6 Months", value: "6" },
  { label: "1 Year", value: "12" },
];

export { DetailsContent, DetailsInputFields, ordersDurationOptions };
